module.exports = __webpack_public_path__ + "img/52.3b469e37.jpg";